import { Link } from "react-router-dom";
import { MapPin, Clock, Briefcase, Calendar } from "lucide-react";
import { formatVacancyComp } from "../lib/vacancyMeta";

export default function VacancyCard({ v }) {
  const comp = formatVacancyComp(v);
  return (
    <Link
      to={`/vacature/${v.id}`}
      data-testid={`vacancy-card-${v.id}`}
      className="ok-card block p-6 group"
    >
      <div className="flex flex-wrap items-start gap-2 mb-3">
        <span className="ok-chip">{v.expertise_category}</span>
        {v.seniority && <span className="ok-chip ok-chip-cream">{v.seniority}</span>}
        {v.contract_type && v.contract_type !== "Beide" && (
          <span className="ok-chip ok-chip-cream">{v.contract_type === "Detacheren/dienstverband" ? "Detacheren" : v.contract_type}</span>
        )}
        {comp && <span className="ok-chip ok-chip-cream">{comp}</span>}
      </div>
      <h3 className="font-display text-xl font-semibold leading-snug group-hover:text-[#01696f] transition-colors line-clamp-2">
        {v.title}
      </h3>
      <div className="mt-4 grid grid-cols-2 gap-2 text-xs text-[#4a5d5e]">
        <span className="inline-flex items-center gap-1.5"><MapPin size={12} />{v.location}</span>
        <span className="inline-flex items-center gap-1.5"><Clock size={12} />{v.hours_per_week} uur/wk</span>
        <span className="inline-flex items-center gap-1.5"><Briefcase size={12} />{v.duration_months} mnd</span>
        {v.deadline && (
          <span className="inline-flex items-center gap-1.5"><Calendar size={12} />Deadline {v.deadline}</span>
        )}
      </div>
      <div className="mt-6 ok-link-arrow text-sm">
        Meer info →
      </div>
    </Link>
  );
}
